function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import { findComponent } from "@brandwatch/axiom-utils";
import Position from "../Position/Position";
import PositionSource from "../Position/PositionSource";
import PositionTarget from "../Position/PositionTarget";
import { DropdownSourceRef } from "./DropdownSource";
import { DropdownTargetRef } from "./DropdownTarget";
import DropdownReactContext from "./DropdownReactContext";
import ReactDOM from "react-dom";
/* eslint-disable react/no-find-dom-node */

export default class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false
    };
  }

  componentDidUpdate() {
    const {
      enabled,
      onRequestClose
    } = this.props;
    const {
      isVisible
    } = this.state;

    if (!enabled && isVisible) {
      this.setState({
        isVisible: false
      });

      if (onRequestClose) {
        onRequestClose();
      }
    }
  }

  getContext() {
    return {
      closeDropdown: () => this.close(),
      openDropdown: () => this.open(),
      toggleDropdown: () => this.toggle(),
      dropdownRef: () => this.el
    };
  }

  toggle() {
    if (this.state.isVisible) {
      return this.close();
    }

    this.open();
  }

  open() {
    const {
      enabled,
      onRequestOpen
    } = this.props;

    if (enabled) {
      this.setState({
        isVisible: true
      });

      if (onRequestOpen) {
        onRequestOpen();
      }
    }
  }

  close() {
    const {
      enabled,
      onRequestClose
    } = this.props;

    if (enabled) {
      this.setState({
        isVisible: false
      });

      if (onRequestClose) {
        onRequestClose();
      }
    }
  }

  render() {
    const {
      children,
      offset,
      position,
      withMask,
      ...rest
    } = this.props;
    const {
      isVisible
    } = this.state;
    return /*#__PURE__*/React.createElement(DropdownReactContext.Provider, {
      value: this.getContext()
    }, /*#__PURE__*/React.createElement(Position, _extends({}, rest, {
      isVisible: isVisible,
      offset: offset,
      onMaskClick: withMask ? () => this.close() : null,
      position: position,
      ref: el => this.el = ReactDOM.findDOMNode(el)
    }), /*#__PURE__*/React.createElement(PositionTarget, null, /*#__PURE__*/React.cloneElement(findComponent(children, DropdownTargetRef))), /*#__PURE__*/React.createElement(PositionSource, null, findComponent(children, DropdownSourceRef))));
  }

}

_defineProperty(Dropdown, "defaultProps", {
  enabled: true,
  position: "bottom",
  showArrow: false
});